import { el } from 'redom';

export function getEmailContactName(contact) {

  const fromName = contact.fromName;
  const fromEmailAddress = contact.fromEmailAddress;

  if (typeof fromName === 'string' && fromName.trim() !== '') {

    if (typeof fromEmailAddress === 'string') {
      return [el('span', fromName), el('span.email-address', ` (${fromEmailAddress})`)];
    }

    return [el('span', fromName)];
  }

  return [el('span', fromEmailAddress)];

}

export function getEmailContactNode(contact) {

  return el('a.recipient-name.user-link', {
    href: `/contacts/${contact._id}`
  }, getEmailContactName(contact));

}

export function parseHRef(href) {

  const result = {
    type: 'webpage-link',
    value: href
  };

  if (href === null || href.trim() === '') {
    result.type = 'empty';
    result.value = '';
  } else if (href.indexOf('mailto:') === 0) {
    const [, email] = href.split('mailto:');
    result.type = 'email-link';
    result.value = email;
  }

  return result;

}

export function getClosesAnchor(element) {

  let el = element;

  while (el !== null) {

    if (el.tagName === 'A') {
      return el;
    }

    el = el.parentNode;

  }

  return null;

}

export function isMessageComplete(message) {

  if (!message.metadata) {
    return true;
  }

  if (message.metadata.isFinal === void 0) {
    return true;
  }

  return message.metadata.isFinal;
}

export function isStreamingMessage(message) {

  if (!message.metadata) {
    return false;
  }

  var generationState = message.metadata.generationState;

  if (!generationState) {
    return false;
  }

  return generationState.status === 'STREAMING';

}